import _ from 'lodash';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import LoginContainer from '../../containers/Login';
import loginBackground from '../../images/loginBackground.jpg';
import mobileLogo from '../../images/mobile/mobile_logo.svg';
import { IconButton } from '@material-ui/core';
import CopyIcon from '@material-ui/icons/FileCopy';

const styles = (theme) => {
	return {
		background: {
			position: 'absolute',
			zIndex: -1,
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
		},
		bgPhoto: {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			backgroundImage: `url('${loginBackground}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			opacity: 0.14,
		},
		bgTopHalf: {
			width: '100%',
			height: '65%',
			borderBottom: '10px solid #E9791E',
			backgroundColor: theme.palette.primary.main,
		},
		bgBottomHalf: {
			width: '100%',
		},
		container: {
			margin: 0,
			width: '100%',
			height: '100%',
			position: 'absolute',
		},
		cardPadding: {
			padding: '50px 50px',
			marginBottom: '20%',
			[theme.breakpoints.up('sm')]: {
				padding: '60px 70px',
			},
			[theme.breakpoints.up('sm')]: {
				padding: '80px 90px',
			},
		},
		logo: {
			width: 250,
			[theme.breakpoints.up('sm')]: {
				width: 320,
			},
		},
		logoSubText: {
			paddingTop: 5,
			letterSpacing: '.8px',
			color: '#333',
			fontWeight: 200,
			textTransform: 'uppercase',
			fontSize: 16,
			whiteSpace: 'noWrap',
			paddingBottom: 20,
			[theme.breakpoints.up('sm')]: {
				fontSize: 21,
				paddingBottom: 30,
			},
			[theme.breakpoints.up('md')]: {
				paddingBottom: 50,
			},
		},
		loginButtonContainer: {
			paddingTop: 20,
		},
		authMessages: {
			minHeight: 40,
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			flexDirection: 'column',
		},
		loginButton: {
			fontSize: 20,
			borderRadius: '100px',
			padding: '20px 70px',
		},
		screenCenter: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			height: '100%',
		},
	};
};

class MobileLogin extends Component {
	constructor(props) {
		super(props);

		// So the new android app passes the device token on load. We write this down
		let deviceToken = _.get(this.props, 'match.params.deviceToken') || undefined;
		if (deviceToken) {
			console.log('Got the device token', deviceToken);
			localStorage.setItem('mobilePushDeviceToken', deviceToken);
		} else {
			deviceToken = localStorage.getItem('mobilePushDeviceToken') || undefined;
		}
		this.state = {
			username: '',
			password: '',
			redirectToReferrer: false,
			formFieldError: {},
			deviceToken,
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (!this.props.authSuccess && prevProps.authSuccess) {
			this.setState({
				redirectToReferrer: true,
			});
		}
	}

	loginSubmitted = (e) => {
		e.preventDefault();
		//- Required fields
		const formFieldError = {};
		[
			{ path: 'username', label: 'GeoTab Name' },
			{ path: 'password', label: 'Password' },
		].forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			return;
		}

		const { username, password } = this.state;
		const params = { password, username };

		const deviceToken = this.state.deviceToken;
		if (deviceToken) {
			params.deviceToken = deviceToken;
		}
		this.props.mobileLogin(params);
	};

	onChangePassword = (e) => {
		const newState = { password: e.target.value };

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);
		delete formFieldError.password;
		newState.formFieldError = formFieldError;
		this.setState(newState);
	};

	onChangeEmail = (e) => {
		const newState = { username: e.target.value };

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);
		delete formFieldError.username;
		newState.formFieldError = formFieldError;
		this.setState(newState);
	};

	fallbackCopyTextToClipboard(text) {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			const successful = document.execCommand('copy');
			const msg = successful ? 'successful' : 'unsuccessful';
			console.warn('Fallback: Copying text command was ' + msg);
		} catch (err) {
			console.error('Fallback: Oops, unable to copy', err);
		}
		document.body.removeChild(textArea);
	}

	onCopyDeviceTokenToClipboard = () => {
		const text = this.state.deviceToken;
		if (!navigator.clipboard) {
			this.fallbackCopyTextToClipboard(text);
			return;
		}
		navigator.clipboard.writeText(text).then(
			function () {},
			function (err) {
				console.error('Async: Could not copy text: ', err);
			}
		);
	};

	render() {
		const {
			classes,
			accessToken,
			isAuthenticating,
			authSuccess,
			authFailure,
			authErrors,
			location,
		} = this.props;

		let formErrors = _.values(this.state.formFieldError);
		if (this.state.redirectToReferrer) {
			return <Redirect to={'/mobile/dashboard'} />;
		}

		const authError = _.get(location, 'state.authError');
		const disableLogin = isAuthenticating;

		return (
			<Grid container align={'center'} className={classes.container}>
				{accessToken && <Redirect to="/mobile/dashboard" />}

				<div className={classes.background}>
					<div className={classes.bgTopHalf} />
					<div className={classes.bgBottomHalf} />
					<div className={classes.bgPhoto} />
				</div>

				<div style={{ width: '100%', marginTop: '10px' }}>
					<div className={classes.screenCenter}>
						<div>
							<Card className={classes.cardPadding}>
								<div>
									<img alt="Logo" src={mobileLogo} className={classes.logo} />
									<div className={classes.logoSubText}>Carrier Management System</div>
								</div>

								<form onSubmit={this.loginSubmitted}>
									<Grid item xs={12} style={{ textAlign: 'left', marginTop: 20 }}>
										<TextField
											autoComplete="username"
											value={this.state.username}
											onChange={this.onChangeEmail}
											label="GeoTab Name"
											fullWidth
											variant="outlined"
										/>
									</Grid>

									<Grid item xs={12} style={{ textAlign: 'left', marginTop: 30 }}>
										<TextField
											value={this.state.password}
											onChange={this.onChangePassword}
											id="password"
											label="Password"
											type="password"
											autoComplete="current-password"
											margin="normal"
											fullWidth
											variant="outlined"
										/>
									</Grid>

									<Grid item xs={12} className={classes.loginButtonContainer}>
										<div className={classes.authMessages}>
											{authSuccess && <div>Success</div>}
											{authError && <div>{authError}</div>}
											{authFailure &&
												authErrors.map((authError, i) => {
													return <div key={i}>{authError}</div>;
												})}
											{!_.isEmpty(formErrors) &&
												formErrors.map((authError, i) => {
													return <div key={i}>{authError}</div>;
												})}
											{isAuthenticating && <div>Authenticating....</div>}
										</div>
										<Button
											variant="contained"
											disabled={disableLogin}
											className={classes.loginButton}
											color="primary"
											// onClick={this.loginClicked}
											type="submit"
										>
											LOGIN
										</Button>
									</Grid>
								</form>
							</Card>
							{this.state.deviceToken ? (
								<div style={{ font: '12px', marginTop: '20px' }}>
									<span>Device Token: {this.state.deviceToken.slice(0, 10)}...</span>
									<IconButton
										aria-label="close"
										className={classes.closeButton}
										onClick={this.onCopyDeviceTokenToClipboard}
									>
										<CopyIcon />
									</IconButton>
								</div>
							) : (
								<span>x Missing Device Token</span>
							)}
						</div>
					</div>
				</div>
			</Grid>
		);
	}
}

MobileLogin.propTypes = {
	accessToken: PropTypes.string,
	isAuthenticating: PropTypes.bool,
	authFailure: PropTypes.bool,
	authSuccess: PropTypes.bool,
	authErrors: PropTypes.array,
	mobileLogin: PropTypes.func,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	//withWidth(),
	LoginContainer,
])(MobileLogin);
